import { isProd } from "@/config";
import { getUTC8TimeString, isDev } from "../utils";
import { nanoid } from "nanoid";
import { post } from "@/helpers/http";
import { detectOS } from "@/handle/newDataWareHose/helper";
import { isMobile } from "react-device-detect";
var BusinessType;
var Theme;
var Action;
var Product;
const isBrowser = "object" !== "undefined";
class ReportData {
  getShortUUID() {
    if (!isBrowser) return nanoid(24);
    let uniqueID = localStorage.getItem(this.UNIQUE_ID);
    if (!uniqueID) {
      uniqueID = nanoid(24);
      localStorage.setItem(this.UNIQUE_ID, uniqueID);
    }
    return uniqueID;
  }
  getUUID() {
    if (!isBrowser) return nanoid(10);
    let sessionId = sessionStorage.getItem(this.SESSION_KEY);
    if (!sessionId) {
      sessionId = nanoid(10);
      sessionStorage.setItem(this.SESSION_KEY, sessionId);
    }
    return sessionId;
  }
  // 初始化公共数据
  initCommonData() {
    return {
      distinct_id: nanoid(),
      time: Date.now(),
      utc_time: getUTC8TimeString(),
      user_id: "",
      hrefUrl: window.location.href,
      uniqueId: this.getShortUUID(),
      sessionId: this.getUUID(),
      count: 1
    };
  }
  // 具体上报函数
  report(params) {
    const _params = {
      ...this.initCommonData(),
      ...(params || {})
    };
    if (isDev()) {
      console.log("埋点参数", _params);
    } else {
      console.log("上报");
      post({
        url: this.API,
        data: params,
        config: {
          withCredentials: false
        }
      });
    }
  }
  getFirstVisitRoute() {
    const checkVisitRecord = () => {
      const visitRecord = localStorage.getItem("visitRecord");
      if (visitRecord) {
        return JSON.parse(visitRecord);
      } else {
        return null;
      }
    };
    const getCurrentTimestamp = () => {
      return Math.floor(Date.now() / 1000);
    };
    const updateVisitRecord = route => {
      const visitRecord = {
        route: route,
        timestamp: getCurrentTimestamp()
      };
      localStorage.setItem("visitRecord", JSON.stringify(visitRecord));
    };
    const getFirstVisit = () => {
      const visitRecord = checkVisitRecord();
      if (visitRecord) {
        const currentTime = getCurrentTimestamp();
        if (currentTime - visitRecord.timestamp <= 24 * 60 * 60) {
          return visitRecord.route;
        }
      }
      updateVisitRecord(window.location.pathname);
      return window.location.pathname;
    };
    const data = getFirstVisit();
    return data;
  }
  getFirstVisitRefRoute() {
    const checkVisitRecord = () => {
      const visitRecord = localStorage.getItem("visitRefRecord");
      if (visitRecord) {
        return JSON.parse(visitRecord);
      } else {
        return null;
      }
    };
    const getCurrentTimestamp = () => {
      return Math.floor(Date.now() / 1000);
    };
    const updateVisitRecord = route => {
      const visitRecord = {
        route: route,
        timestamp: getCurrentTimestamp()
      };
      localStorage.setItem("visitRefRecord", JSON.stringify(visitRecord));
    };
    const getFirstVisit = () => {
      const visitRecord = checkVisitRecord();
      if (visitRecord) {
        const currentTime = getCurrentTimestamp();
        if (currentTime - visitRecord.timestamp <= 24 * 60 * 60) {
          return visitRecord.route;
        }
      }
      updateVisitRecord(document.referrer);
      return document.referrer;
    };
    const data = getFirstVisit();
    return data;
  }
  // 之下的都是业务层调用的具体埋点函数 逻辑都收在这里处理
  // 移动端按钮点击分享埋点
  reportShareBtn(params) {
    var _document;
    const properties = {
      product: "a1",
      start_time: getUTC8TimeString(),
      user_agent: window.navigator.userAgent,
      device_type: this.dataWareHouse.deviceType,
      os: this.dataWareHouse.os,
      screen_magnification: window.devicePixelRatio,
      screen_resolution: this.dataWareHouse.screenResolution,
      browser_window_size: this.dataWareHouse.browserWindowSize,
      userLanguage: window.navigator.language,
      originUrl: localStorage.getItem(this.ORIGIN_URL) || "",
      ABtest: localStorage.getItem(this.AB_TEST_ID) || "",
      // 区分分享进来还是其他渠道进来的
      isShare: false,
      // 记录来源渠道
      referrerurl: (_document = document) === null || _document === void 0 ? void 0 : _document.referrer
    };
    const _params = {
      action: "leave",
      theme: "behaviour",
      ...(params || {}),
      properties
    };
    this.report(_params);
  }
  // topic页进入时发送
  initTopicPage() {
    const urlParams = new URLSearchParams(location.search);
    const sourceParam = urlParams.get("source") != null ? urlParams.get("source") : "";
    const planParam = urlParams.get("plan") != null ? urlParams.get("plan") : "";
    const traceParam = urlParams.get("traceId") != null ? urlParams.get("traceId") : "";
    const params = {
      business_type: "A1",
      theme: "behaviour",
      action: "userpath",
      user_id: "1749241720583962625",
      properties: {
        user_agent: window.navigator.userAgent,
        device_type: this.dataWareHouse.deviceType,
        os: this.dataWareHouse.os,
        screen_magnification: window.devicePixelRatio,
        screen_resolution: this.dataWareHouse.screenResolution,
        browser_window_size: this.dataWareHouse.browserWindowSize,
        userLanguage: window.navigator.language,
        originUrl: localStorage.getItem(this.ORIGIN_URL) || "",
        source: sourceParam,
        plan: planParam,
        traceId: traceParam || localStorage.getItem("traceId") ? localStorage.getItem("traceId") : "",
        firstenterurl: this.getFirstVisitRoute(),
        referrerurl: this.getFirstVisitRefRoute(),
        isnew: false,
        preUrl: document.referrer ? document.referrer : ""
      }
    };
    this.report(params);
  }
  // 点击导流弹窗确定
  clickOpenImportModal() {
    const params = {
      business_type: "A1",
      theme: "behaviour",
      action: "h5_popup_click",
      user_id: "",
      uniqueId: this.getShortUUID(),
      properties: {
        product: "a1",
        start_time: getUTC8TimeString(),
        user_agent: window.navigator.userAgent,
        device_type: this.dataWareHouse.deviceType,
        os: this.dataWareHouse.os,
        screen_magnification: window.devicePixelRatio,
        screen_resolution: this.dataWareHouse.screenResolution,
        browser_window_size: this.dataWareHouse.browserWindowSize,
        userLanguage: window.navigator.language,
        originUrl: localStorage.getItem(this.ORIGIN_URL) || "",
        type: "seo_popup",
        button_name: "download"
      }
    };
    this.report(params);
  }
  // 关闭导流弹窗
  closeOpenImportModal() {
    const params = {
      business_type: "A1",
      theme: "behaviour",
      action: "h5_popup_click",
      user_id: "",
      uniqueId: this.getShortUUID(),
      properties: {
        product: "a1",
        start_time: getUTC8TimeString(),
        user_agent: window.navigator.userAgent,
        device_type: this.dataWareHouse.deviceType,
        os: this.dataWareHouse.os,
        screen_magnification: window.devicePixelRatio,
        screen_resolution: this.dataWareHouse.screenResolution,
        browser_window_size: this.dataWareHouse.browserWindowSize,
        userLanguage: window.navigator.language,
        originUrl: localStorage.getItem(this.ORIGIN_URL) || "",
        type: "seo_popup",
        button_name: "close"
      }
    };
    this.report(params);
  }
  // 打开导流弹窗
  beforeOpenImportModal() {
    const params = {
      business_type: "A1",
      theme: "behaviour",
      action: "h5_popup_show",
      user_id: "",
      uniqueId: this.getShortUUID(),
      properties: {
        product: "a1",
        start_time: getUTC8TimeString(),
        user_agent: window.navigator.userAgent,
        device_type: this.dataWareHouse.deviceType,
        os: this.dataWareHouse.os,
        screen_magnification: window.devicePixelRatio,
        screen_resolution: this.dataWareHouse.screenResolution,
        browser_window_size: this.dataWareHouse.browserWindowSize,
        userLanguage: window.navigator.language,
        originUrl: localStorage.getItem(this.ORIGIN_URL) || "",
        preUrl: document.referrer ? document.referrer : "",
        type: "seo_popup"
      }
    };
    this.report(params);
  }
  constructor() {
    var _document_referrer, _document;
    this.SESSION_KEY = "sessionId";
    this.UNIQUE_ID = "uniqueID";
    this.API = isProd ? "https://data.a1.art" : "https://aws-test-data.geesdev.com";
    this.ORIGIN = "origin";
    this.RANK_LOCATION = "rankLocation";
    this.SUBSCRIBE_LOCATION = "subscribeLocation";
    this.USER_LOCATION = "userLocation";
    this.AB_TEST_ID = "ABtestId" // AB Test ID
    ;
    this.ORIGIN_URL = "originURL" // 埋点
    ;
    this.dataWareHouse = {
      location: "none",
      generateid: "none",
      origin: isBrowser && ((_document = document) === null || _document === void 0 ? void 0 : (_document_referrer = _document.referrer) === null || _document_referrer === void 0 ? void 0 : _document_referrer.startsWith("https://a1.art")) ? localStorage.getItem(this.ORIGIN) || "none" : "none",
      tab: "collection",
      rankLocation: isBrowser ? localStorage.getItem(this.RANK_LOCATION) || "none" : "none",
      userLocation: isBrowser ? localStorage.getItem(this.USER_LOCATION) || "other" : "other",
      subscribeLocation: isBrowser ? localStorage.getItem(this.SUBSCRIBE_LOCATION) || "none" : "none",
      originImageId: "none",
      traceInfoList: new Map(),
      deviceType: isBrowser ? isMobile ? "MOBILE" : "PC" : "PC",
      os: isBrowser ? detectOS() : "unknown",
      screenResolution: isBrowser ? window.screen.width + "x" + window.screen.height : "0x0",
      browserWindowSize: isBrowser ? window.innerWidth + "x" + window.innerHeight : "0x0"
    };
  }
}
export const ReportDataInstance = new ReportData();